import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark",
  "use": "checkmark-usage",
  "viewBox": "0 0 41.86 37.01",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 41.86 37.01\" id=\"checkmark\"><defs><style>#checkmark .cls-1{fill:#8abf2e;}</style></defs><title>Asset 1</title><g id=\"checkmark_Layer_2\" data-name=\"Layer 2\"><g id=\"checkmark_Art\"><polygon class=\"cls-1\" points=\"9.27 37.01 0 18.36 5.6 15.57 11 26.44 37.44 0 41.86 4.42 9.27 37.01\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol